// @ts-nocheck
import { useState } from "react";

function useItem() {
    const [selectedItems, setItemFilter] = useState<string[]>([]);

    function toggleItem(item: string) {
        const ItemIndex = selectedItems.findIndex(itemnumber => itemnumber === item);
        if (ItemIndex >= 0) {
            setItemFilter([...selectedItems.slice(0, ItemIndex), ...selectedItems.slice(ItemIndex + 1)]);
        } else {
            setItemFilter([...selectedItems, String(item)]);
        }
    }

    function toggleAllItems(itemIds: string[]) {
        let selectedItemsTemp = selectedItems;
        let iSelectedItems = 0;
        let isAllSelected = false;

        [...itemIds].forEach(id => {
            const itemT = selectedItems.find(item => item === id);
            if (itemT) {
                iSelectedItems++;
                selectedItemsTemp = selectedItemsTemp.filter(item => item !== itemT);
            }
        });
        isAllSelected = iSelectedItems === itemIds.length;

        if (!isAllSelected) {
            selectedItemsTemp = [...selectedItemsTemp, ...itemIds];
        }

        setItemFilter(selectedItemsTemp);
    }

    return {
        selectedItems,
        toggleItem,
        toggleAllItems,
    };
}

export default useItem;
